var map = {
	"./icon-1-active.png": 602,
	"./icon-1.png": 1577,
	"./icon-2-active.png": 915,
	"./icon-2.png": 2692,
	"./icon-3-active.png": 9917,
	"./icon-3.png": 2032,
	"./icon-4-active.png": 1419,
	"./icon-4.png": 250,
	"./icon-5-active.png": 660,
	"./icon-5.png": 4908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7050;